import { createApi } from '@reduxjs/toolkit/query/react';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';
import type {
    GenerateMemberReferralCodeApiRequest,
    GenerateMemberReferralCodeApiResponse,
} from 'tradera/state/services/types/webapi-member-generated';

export const referralModalApi = createApi({
    reducerPath: 'referralModalApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getReferralCode: builder.query<
            GenerateMemberReferralCodeApiResponse,
            GenerateMemberReferralCodeApiRequest
        >({
            query: () => {
                return {
                    url: '/api/webapi/member/referral-code',
                    method: 'POST',
                };
            },
        }),
    }),
});

export const { useGetReferralCodeQuery } = referralModalApi;
